import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { StatusChip } from '@/components/ui/status-chip';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import {
  customerLabel,
  EngineerVM,
  engineerVMPhase,
  engineerVMPhaseLabel,
  engineerVMPhaseVariant,
  useEngineerVMs,
} from '@/hooks/useEngineerVMs';
import { EngineerVMDrawer } from '@/sections/customerManagement/components/engineerVMs/EngineerVMDrawer';
import { LaunchVMDialog } from '@/sections/customerManagement/components/engineerVMs/LaunchVMDialog';
import { useAuth } from '@/state/auth';

export function EngineerVMSection() {
  const { data: vms = [], isLoading } = useEngineerVMs();
  const { me } = useAuth();
  const [launchOpen, setLaunchOpen] = useState(false);
  const [selected, setSelected] = useState<EngineerVM | null>(null);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-chariot-text-secondary text-sm">
          Ad-hoc per-engineer cloud workspaces across every customer you manage.
        </p>
        <Button onClick={() => setLaunchOpen(true)}>Launch VM</Button>
      </div>

      {isLoading ? (
        <p className="text-chariot-text-secondary text-sm">Loading…</p>
      ) : vms.length === 0 ? (
        <p className="text-chariot-text-secondary text-sm">
          No engineer VMs yet.
        </p>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Customer</TableHead>
              <TableHead>VM ID</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Tier</TableHead>
              <TableHead>Private IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {vms.map(vm => (
              <TableRow
                key={vm.vm_id}
                className="cursor-pointer"
                onClick={() => setSelected(vm)}
              >
                <TableCell className="max-w-[220px] truncate text-xs">
                  {customerLabel(vm.tenant, me)}
                </TableCell>
                <TableCell className="font-mono text-xs">{vm.vm_id}</TableCell>
                <TableCell>
                  <StatusChip
                    label={engineerVMPhaseLabel[engineerVMPhase(vm)]}
                    variant={engineerVMPhaseVariant[engineerVMPhase(vm)]}
                  />
                </TableCell>
                <TableCell>{vm.tier || '—'}</TableCell>
                <TableCell>{vm.private_ip || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <LaunchVMDialog open={launchOpen} onOpenChange={setLaunchOpen} />
      <EngineerVMDrawer vm={selected} onClose={() => setSelected(null)} />
    </div>
  );
}
